module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manu-management-component/manu-management-list/manu-management-list.component.css
// module id = ./src/app/manu-management-component/manu-management-list/manu-management-list.component.css
// module chunks = main